// extracted by mini-css-extract-plugin
export var select = "_re-0";